// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3Qknh","header":"Messages_header__1N5Vt"};